import React from "react";
import Logo from "../../../assets/images/nn-asig-logo.png";
import "./Navbar.css";

const Navbar = () => {
  return (
    <div className="navigation">
      <div className="fixed-top bg-white">
        <div className="container pl-0 pr-0 padding-sm">
          <div className="row">
            <div className="col-12 pl-0 pr-0">
              <nav className="navbar navbar-light bg-white">
                <a className="navbar-brand" href="https://www.nn.ro/">
                  <img
                    src={Logo}
                    alt="logo NN"
                    className="d-inline-block align-top logo-navbar"
                  />
                </a>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
